<template>
  <div class="smardie-quantity-stepper" role="group" :aria-label="ariaLabel">
    <button
      type="button"
      class="smardie-quantity-stepper__btn smardie-quantity-stepper__btn--minus"
      :disabled="numericValue <= min"
      :aria-label="decreaseLabel"
      @click="decrement"
    >
      <i class="minus icon" aria-hidden="true"></i>
    </button>
    <div class="smardie-quantity-stepper__value" aria-live="polite">{{ displayValue }}</div>
    <button
      type="button"
      class="smardie-quantity-stepper__btn smardie-quantity-stepper__btn--plus"
      :disabled="numericValue >= max"
      :aria-label="increaseLabel"
      @click="increment"
    >
      <i class="plus icon" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
export default {
  name: 'QuantityStepper',
  compatConfig: {
    COMPONENT_V_MODEL: false
  },
  props: {
    modelValue: {
      type: [Number, String],
      default: 0
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 99
    },
    ariaLabel: {
      type: String,
      default: 'Quantity'
    }
  },
  computed: {
    numericValue: function () {
      const n = Number(this.modelValue)
      if (!Number.isFinite(n)) return this.min
      return Math.round(n)
    },
    displayValue: function () {
      return this.numericValue
    },
    decreaseLabel: function () {
      return 'Decrease quantity'
    },
    increaseLabel: function () {
      return 'Increase quantity'
    }
  },
  methods: {
    decrement: function () {
      if (this.numericValue <= this.min) return
      this.$emit('update:modelValue', this.numericValue - 1)
    },
    increment: function () {
      if (this.numericValue >= this.max) return
      this.$emit('update:modelValue', this.numericValue + 1)
    }
  }
}
</script>
